export const COMPANY_MANAGER = "Company Manager";
export const AUDITOR = "Auditor";
export const CONTRACTOR = "Contractor";
export const GUEST = "Guest";
export const PROGRAM_ADMIN = "Program Admin";
export const OM_SUPER_ADMIN = "OM Super Admin";
export const OM_SUPPORT = "OM Support";
export const INTERNAL_ROLES = [OM_SUPER_ADMIN,OM_SUPPORT];
